'use es6';

import * as Actions from 'FormsUI/actions/FormThemes';
import * as RequestState from 'FormsCommonComponents/lib/RequestState';
const INIT_STATE = {
  themes: [],
  requestState: RequestState.NOT_REQUESTED
};
export function formThemes(state = INIT_STATE, action) {
  switch (action.type) {
    case Actions.REQUEST_THEMES:
      return Object.assign({}, state, {
        requestState: RequestState.REQUESTED
      });
    case Actions.SUCCEED_GETTING_THEMES:
      return Object.assign({}, state, {
        requestState: RequestState.SUCCEEDED
      });
    case Actions.RECEIVE_THEMES:
      return Object.assign({}, state, {
        themes: action.themes.reduce((memo, theme) => Object.assign({}, memo, {
          [theme.themeName]: theme
        }), {})
      });
    case Actions.FAILED_GETTING_THEMES:
      return Object.assign({}, state, {
        requestState: RequestState.FAILED
      });
    default:
      return state;
  }
}